"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var IncompleteStep = function IncompleteStep(_ref) {
  var step = _ref.step,
    circleStroke = _ref.circleStroke,
    circleFill = _ref.circleFill,
    textStroke = _ref.textStroke,
    textFill = _ref.textFill;
  return /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    height: "30",
    width: "30"
  }, /*#__PURE__*/_react.default.createElement("title", null, "Incomplete Step"), /*#__PURE__*/_react.default.createElement("circle", {
    cx: "15",
    cy: "15",
    r: "10",
    stroke: circleStroke,
    fill: circleFill,
    strokeWidth: "2px"
  }), /*#__PURE__*/_react.default.createElement("text", {
    x: "50%",
    y: "50%",
    textAnchor: "middle",
    stroke: textStroke,
    fill: textFill,
    strokeWidth: "1px",
    dy: ".3em",
    fontSize: "10"
  }, step));
};
IncompleteStep.propTypes = {
  step: _propTypes.default.string.isRequired,
  circleStroke: _propTypes.default.string,
  circleFill: _propTypes.default.string,
  textStroke: _propTypes.default.string,
  textFill: _propTypes.default.string
};
IncompleteStep.defaultProps = {
  circleStroke: '#99b1bf',
  circleFill: 'none',
  textStroke: '#99b1bf',
  textFill: '#ffffff'
};
var _default = exports.default = IncompleteStep;
require('/var/lib/jenkins/workspace/pf-lcps-ui_Release_0/node_modules/@pf-loan-funnel/pf-select-plan/node_modules/@pf-loan-funnel/pf-component-library/lib/styles.scss');